export enum ServiceSlotStatus {
  AVAILABLE = 'Available',
  ALMOST_FULL = 'Almost Full',
  FULL = 'Full'
}

export interface TimeSlotSession {
  begin: string
  end: string
  status?: ServiceSlotStatus
  processingTaskCount?: number
  slotsPerSession: number
  midday?: string
}

export interface TimeSlotDto {
  name: string
  enable: boolean
  sessions: TimeSlotSession[]
  slotsPerSession: number
}

export interface ListTimeSlotResponseDto {
  items: TimeSlotDto[]
}

export type ScheduleCalendarConfigurationType = {
  [name: string]: TimeSlotDto
}

export interface GetTimeSlotByDateResponseDto {
  timeSlots: TimeSlotSession[]
}

export interface TimeSlotDurationDto {
  begin: string
  end: string
  status: 'Available' | 'Unavailable'
}
